import { ArrowsAltOutlined, CloseOutlined, FormOutlined, RobotOutlined } from '@ant-design/icons'
import { Button, Tag, Typography } from 'antd'
import { memo, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

// モードごとに出すボタンが違うので、モードと、そのモードのボタンを押したときの処理を組にして受け取る。
// compact：新しいチャット、広げる、閉じる。expanded：新しいチャット、閉じる。
// 履歴のボタンと開いているチャットの名前は、チャットの一覧を出す #10112 で足す
type AgentHeaderProperties = {
  // 新しいチャットを始める。まだ指示を送っていない（始め直すものがない）ときは押せない
  onNewChat: () => void
  canStartNewChat: boolean
  onClose: () => void
} & ({ mode: 'compact'; onExpand: () => void } | { mode: 'expanded' })

const AgentHeaderView = (properties: AgentHeaderProperties): ReactElement => {
  const { t } = useTranslation()

  return (
    <header className="flex items-center gap-1">
      <RobotOutlined />
      <Typography.Text strong className="shrink-0">
        {t(`エージェント`)}
      </Typography.Text>
      {/* ベータの表示（PdM の要件 T-2） */}
      <Tag className="m-0 shrink-0" color="blue">
        {t(`β版`)}
      </Tag>
      <div className="flex-1" />
      {/* 入力欄からも使える（PdM の要件）。パネルを開かずに、会話を始め直せるようにするためである */}
      <Button
        type="text"
        size="small"
        icon={<FormOutlined />}
        aria-label={t(`新しいチャット`)}
        disabled={!properties.canStartNewChat}
        onClick={() => {
          properties.onNewChat()
        }}
      />
      {properties.mode === 'compact' && (
        <Button
          type="text"
          size="small"
          icon={<ArrowsAltOutlined />}
          aria-label={t(`広げる`)}
          onClick={() => {
            properties.onExpand()
          }}
        />
      )}
      {/* 閉じると、入力欄からもパネルからも入口に戻る */}
      <Button
        type="text"
        size="small"
        icon={<CloseOutlined />}
        aria-label={t(`閉じる`)}
        onClick={() => {
          properties.onClose()
        }}
      />
    </header>
  )
}

// 回答が伸びてウィジェットが描き直されても、見出しは描き直さない
export const AgentHeader = memo(AgentHeaderView)
